import { faArrowSquareLeft } from "@jewlr/pro-light-svg-icons/faArrowSquareLeft"
import {
  Button,
  FontAwesomeIcon,
  MediaBox,
  MediaFlex,
  Typography,
} from "@jewlr/storybook/core"
import { useId } from "@react-aria/utils"
import PropTypes from "prop-types"
import { useState } from "react"
import styled from "styled-components"

import HeroBanner from "areas/landing/elements/hero-banner"
import Slider from "dependencies/carousel"

const SliderWrapper = styled(Slider)`
  button[aria-label="next"] {
    transform: scaleX(-1);
  }

  button[aria-label="previous"] {
    transform: none;
  }
`

const AnnouceMessage = styled(MediaBox).attrs((props) => ({
  fontSize: "16px",
  left: "0",
  lessThan: "tablet",
  letterSpacing: "-0.02em",
  lineHeight: "20px",
  position: "absolute",
  px: 2,
  py: "12px",
  top: "0",
  ...props,
}))``

const CarouselArrows = ({
  color,
  id,
  nextDisabled,
  nextSlide,
  previousDisabled,
  previousSlide,
}) => (
  <MediaFlex alignItems="center" greaterThanOrEqual="tablet" pb={4} pr={6}>
    <Button
      aria-controls={`${id}-slider-frame`}
      aria-label="previous"
      disabled={previousDisabled}
      mr={1}
      onClick={previousSlide}
    >
      <FontAwesomeIcon color={color} fontSize="32px" icon={faArrowSquareLeft} />
    </Button>
    <Button
      aria-controls={`${id}-slider-frame`}
      aria-label="next"
      disabled={nextDisabled}
      onClick={nextSlide}
    >
      <FontAwesomeIcon color={color} fontSize="32px" icon={faArrowSquareLeft} />
    </Button>
  </MediaFlex>
)

CarouselArrows.propTypes = {
  color: PropTypes.string,
  id: PropTypes.string,
  nextDisabled: PropTypes.bool,
  nextSlide: PropTypes.func,
  previousDisabled: PropTypes.bool,
  previousSlide: PropTypes.func,
}

const HomepageBannerCarousel = ({ banners, order }) => {
  const [slideIndex, setSlideIndex] = useState(0)
  const carouselId = useId()

  const shuffledBanners = order.map((id) => banners[id])
  const controlColor =
    shuffledBanners[slideIndex].style?.block_style?.color || "white"

  const sliderSettings = {
    autoplay: true,
    autoplayInterval: 5000,
    beforeSlide: (_, index) => setSlideIndex(index),
    carouselId,
    frameAriaLabel: "Featured Sales",
    plugin: (
      <AnnouceMessage aria-hidden color={controlColor}>
        <Typography>
          0{slideIndex + 1} / 0{shuffledBanners.length}
        </Typography>
      </AnnouceMessage>
    ),
    renderBottomCenterControls: null,
    renderBottomRightControls: (props) => (
      <CarouselArrows color={controlColor} id={carouselId} {...props} />
    ),
    renderCenterLeftControls: null,
    renderCenterRightControls: null,
    speed: 1000,
    wrapAround: true,
  }

  return (
    <>
      <SliderWrapper {...sliderSettings}>
        {shuffledBanners.map((banner, index) => (
          <HeroBanner
            element={banner}
            key={`homepage-banner-${index}`}
            lazyload={index > 0}
          />
        ))}
      </SliderWrapper>
    </>
  )
}

HomepageBannerCarousel.propTypes = {
  banners: PropTypes.object,
  order: PropTypes.array,
}

export default HomepageBannerCarousel
